module.exports = __webpack_public_path__ + "img/lofi.d294370e.jpg";